import React from 'react';
import { Link } from 'react-router-dom';
import './SingleAlbumFull.css'
import { environments } from 'environments/environments';
import { Album } from '../Album.interface';

class SingleAlbumFull extends React.Component {
  state = {
    textOpened: 0,
    album: undefined as Album | undefined
  }

  componentDidMount() {
    this.getAlbumData();
  }

  getAlbumData() {
    fetch(`${environments.serverURL}/data/albums.json?anticache=${Date.now()}`)
      .then(async response => {
        const data: Album[] = await response.json();
        const albumName = (this.props as any).match.params.name;
        const album = data.find(album => album.name === albumName);
        if (album) {
          this.setState({ album });
        }
        // TODO: Display error message to user when album not found
      })
      // TODO: Display error message to user when albums not loaded
      .catch(e => console.error('Detaily alba se nepovedlo načíst.\n', e));
  }

  toggleText(songIndex: number) {
    const opened = this.state.textOpened === songIndex ? 0 : songIndex;
    this.setState({ textOpened: opened });
  }

  render() {
    const album = this.state.album;
    const renderInterprets = album ? album.interprets.map((interpret, index) => <p key={index}>{interpret}</p>) : null;
    const renderSongs = album && album.songs ? album.songs.map((song, index) => {
      const renderLyrics = song.lyrics ? song.lyrics.split('\n').map((line, index) => <p key={index}>{line}&nbsp;</p>) : null;
      const lyricsShown = this.state.textOpened === index + 1;
      const lyricsClass = 'song-lyrics' + (lyricsShown ? ' song-lyrics-opened' : '');
      return (
        <div key={index} className="song-line">
          <span className="song-line-left">
            <span className="song-name">{index + 1}. <b>{song.name}</b></span>
            <span className="song-details">{song.details || ''}</span>
          </span>
          <span className="song-line-right">
            {renderLyrics
              ? <span className="song-action" onClick={() => this.toggleText(index + 1)}>{lyricsShown ? 'SKRÝT' : 'UKÁZAT'} TEXT</span>
              : null
            }
            {song.mp3
              ? <a target="_blank" rel="noopener noreferrer" href={song.mp3}>
                {song.mp3.endsWith('mp3')
                  ? <span className="song-action">STÁHNOUT MP3</span>
                  : <span className="song-action">Poslechnout</span>
                }
              </a>
              : null
            }
          </span>
          {renderLyrics
            ? (
              <span className={lyricsClass}>
                <p className="big-song-name">{song.name}</p>
                <br />
                {renderLyrics}
                <br />
              </span>
            )
            : null
          }
        </div>
      )
    }) : null;
    const src = album && album.cover
      ? album.cover.startsWith('http')
        ? album.cover
        : environments.server + album.cover
      : ''

    return (
      <div>
        <Link to="/diskografie" className="go-back">&larr; Zpět na seznam alb</Link>
        <div className="full-album">
          <img className="full-album-cover" src={src} alt={'Cover alba ' + (album ? album.name : '(nenalezeno)')} />
          <div className="full-album-details">
            <div>
              <p className="full-album-name">Název: <b>{album ? album.name : 'Nenalezen'}</b></p>
              <p>Rok vydání alba: {album ? album.released : 'kdo ví kdy'}</p>
            </div>
            <div className="full-album-team">
              {renderInterprets}
            </div>
          </div>
        </div>
        {renderSongs}
      </div>
    );
  }
}

export default SingleAlbumFull;